import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'mpp-pta-close-modal',
  templateUrl: './pta-close-modal.component.html',
  styleUrls: ['./pta-close-modal.component.scss'],
  standalone: false,
})
export class PtaCloseModalComponent {
  constructor(private dialogRef: MatDialogRef<PtaCloseModalComponent>) {}

  closeModal(): void {
    this.dialogRef.close();
  }
}
